/* Vibrant Florals: native Shopify forms with progressively enhanced interactions. */
(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const root = document.body.dataset.root || '/';
  const route = p => `${root.replace(/\/$/, '')}/${p}`;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let lastFocus, cartQueue = Promise.resolve(), cartMutationError = null;
  const recommendationLoads = [];
  const controllers = new WeakMap();
  const announce = text => { const el = $('#LiveStatus'); if (el) el.textContent = text; };
  const errorMessage = error => error?.message || 'Une erreur est survenue. Veuillez réessayer.';
  async function request(url, options = {}) {
    const response = await fetch(url, { ...options, headers: { 'X-Requested-With': 'XMLHttpRequest', ...options.headers } });
    if (!response.ok) {
      let message = 'Impossible de terminer cette action. Veuillez réessayer.';
      try { const data = await response.json(); message = data.description || data.message || message; } catch (_) { /* HTTP error without JSON */ }
      throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
    }
    return response;
  }
  function openDialog(dialog, trigger) {
    if (!dialog) return;
    $$('dialog[open]').forEach(closeDialog);
    lastFocus = trigger || document.activeElement;
    dialog._returnFocus = lastFocus;
    dialog.showModal();
    document.body.classList.add('modal-open');
    $$(`[data-open="${dialog.id}"]`).forEach(x => x.setAttribute('aria-expanded', 'true'));
    const focus = $('input:not([type=hidden]), [data-close], button, a', dialog);
    focus?.focus();
  }
  function closeDialog(dialog) {
    if (!dialog?.open) return;
    $$('video', dialog).forEach(video => { video.pause(); try { video.currentTime = 0; } catch (_) {} });
    $$('iframe', dialog).forEach(frame => frame.remove());
    if (dialog.id === 'MediaModal') $('[data-media-body]', dialog).replaceChildren();
    dialog.close();
    $$(`[data-open="${dialog.id}"]`).forEach(x => x.setAttribute('aria-expanded', 'false'));
    if (!$('dialog[open]')) document.body.classList.remove('modal-open');
    if (dialog._returnFocus?.isConnected) dialog._returnFocus.focus();
  }
  function externalFrame(host, id) {
    const frame = document.createElement('iframe');
    const safeId = encodeURIComponent(id || '');
    frame.src = host === 'youtube' ? `https://www.youtube-nocookie.com/embed/${safeId}?autoplay=1&rel=0` : `https://player.vimeo.com/video/${safeId}?autoplay=1`;
    frame.allow = 'autoplay; fullscreen; picture-in-picture'; frame.allowFullscreen = true;
    frame.title = 'Vidéo Vibrant Florals'; return frame;
  }
  function pauseOtherVideos(active) { $$('video').forEach(v => { if (v !== active) v.pause(); }); }
  document.addEventListener('play', e => { if (e.target.tagName === 'VIDEO') pauseOtherVideos(e.target); }, true);
  document.addEventListener('cancel', e => { if (e.target.tagName === 'DIALOG') { e.preventDefault(); closeDialog(e.target); } }, true);
  document.addEventListener('keydown', e => {
    const dialog = $('dialog[open]');
    if (e.key === 'Escape') {
      if (dialog) { e.preventDefault(); closeDialog(dialog); }
      else $$('nav details[open], .filter[open]').forEach(d => { d.open = false; $('summary', d)?.focus(); });
    }
    if (e.key === 'Tab' && dialog) {
      const focusable = $$('a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),summary,video[controls],iframe,[tabindex="0"]', dialog).filter(el => el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
    }
  });
  document.addEventListener('click', async e => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.open);
      if (target) { e.preventDefault(); openDialog(target, opener); if (target.id === 'CartDrawer') refreshCart().catch(err => showCartError(err)); }
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    if (e.target.tagName === 'DIALOG') { const rect = e.target.getBoundingClientRect(); if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) closeDialog(e.target); }
    if (e.target.closest('#MobileMenu a')) closeDialog($('#MobileMenu'));
    if (!e.target.closest('.desktop-nav')) $$('.desktop-nav details[open]').forEach(d => d.open = false);
    if (!e.target.closest('.filter')) $$('.filter[open]').forEach(d => d.open = false);
    const zoom = e.target.closest('[data-zoom]');
    if (zoom) { const img = document.createElement('img'); img.src = zoom.dataset.zoom; img.alt = $('img', zoom)?.alt || zoom.getAttribute('aria-label') || 'Aperçu'; $('[data-media-body]').replaceChildren(img); openDialog($('#MediaModal'), zoom); return; }
    const story = e.target.closest('[data-story]');
    const external = e.target.closest('button[data-external-host]');
    if (story || external) {
      pauseOtherVideos(null);
      const body = $('[data-media-body]'); body.replaceChildren();
      if (story) { const template = document.getElementById(story.dataset.story); if (!template) return; body.append(template.content.cloneNode(true)); const placeholder = $('[data-external-host]', body); if (placeholder) placeholder.replaceWith(externalFrame(placeholder.dataset.externalHost, placeholder.dataset.externalId)); }
      else body.append(externalFrame(external.dataset.externalHost, external.dataset.externalId));
      openDialog($('#MediaModal'), story || external);
      const video = $('video', body); if (video) video.play().catch(() => { /* user can start with native controls */ });
      return;
    }
    const thumb = e.target.closest('[data-thumbnail]');
    if (thumb) { const gallery = thumb.closest('[data-gallery]'); $$('[data-media-id]', gallery).forEach(el => { el.hidden = el.dataset.mediaId !== thumb.dataset.thumbnail; $$('video', el).forEach(v => v.pause()); }); $$('[data-thumbnail]', gallery).forEach(el => el.setAttribute('aria-pressed', String(el === thumb))); }
    const quantity = e.target.closest('[data-quantity]');
    if (quantity) { const input = $('input', quantity.parentElement); const min = Number(input.min) || 1, max = input.max ? Number(input.max) : Infinity, step = Number(input.step) || 1; input.value = Math.min(max, Math.max(min, (Number(input.value) || min) + Number(quantity.dataset.quantity) * step)); input.dispatchEvent(new Event('change', { bubbles: true })); }
    const cartStep = e.target.closest('[data-cart-step]');
    if (cartStep) { const input = $('input', cartStep.parentElement); input.value = Math.max(0, Number(input.value) + Number(cartStep.dataset.cartStep) * (Number(input.step) || 1)); input.dispatchEvent(new Event('change', { bubbles: true })); }
    const remove = e.target.closest('[data-remove-key]');
    if (remove) { e.preventDefault(); enqueueCart({ id: remove.dataset.removeKey, quantity: 0 }); }
  });
  document.addEventListener('toggle', e => {
    if (e.target.matches('.desktop-nav>ul>li>details') && e.target.open) $$('.desktop-nav>ul>li>details[open]').forEach(d => { if (d !== e.target) d.open = false; });
  }, true);
  function updateWhatsApp(section) {
    const link = $('[data-product-whatsapp]', section); if (!link) return;
    const selected = $$('[data-option-value-id]:checked', section).map(x => `${x.dataset.optionName} : ${x.value}`);
    const quantity = $('[name=quantity]', section)?.value || '1';
    const url = new URL(section.dataset.productUrl, location.origin); const id = $('[name=id]', section)?.value; if (id) url.searchParams.set('variant', id);
    const message = ['Bonjour, je souhaite commander :', section.dataset.productTitle, ...selected, `Quantité : ${quantity}`, url.href].join('\n');
    link.href = `https://wa.me/${section.dataset.whatsapp}?text=${encodeURIComponent(message)}`;
  }
  async function changeVariant(input) {
    const section = input.closest('[data-product-section]'); if (!section) return;
    controllers.get(section)?.abort();
    const controller = new AbortController(); controllers.set(section, controller);
    const quantity = $('[name=quantity]', section)?.value || '1', focusId = input.id;
    const target = input.dataset.productUrl || section.dataset.productUrl;
    if (input.dataset.productUrl && input.dataset.productUrl !== section.dataset.productUrl) { location.assign(input.dataset.productUrl); return; }
    const url = new URL(target, location.origin);
    const selected = $$('[data-option-value-id]:checked', section).map(x => x.dataset.optionValueId);
    url.searchParams.set('option_values', selected.join(',')); url.searchParams.set('section_id', section.dataset.sectionId);
    section.classList.add('pending'); section.setAttribute('aria-busy', 'true');
    // Keyboard submissions must not buy the previous variant while a selection is loading.
    $$('[name=id], [data-add-button], [data-buy-now], .sticky-cart button', section).forEach(el => el.disabled = true);
    try {
      const response = await request(url.href, { signal: controller.signal });
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updated = $('[data-product-section]', doc); if (!updated) throw new Error('Impossible de mettre à jour les options.');
      const q = $('[name=quantity]', updated);

if (q) {
  const min = Number(q.min) || 1;
  const step = Number(q.step) || 1;
  const max = q.max ? Number(q.max) : Infinity;

  q.value = Math.min(
    max,
    min + Math.max(
      0,
      Math.ceil((Number(quantity) - min) / step)
    ) * step
  );
}

/*
 * Update only the variant-related elements.
 * The existing product section and injected COD button remain untouched.
 */


/* Update the product gallery without resetting the selected image */
const currentGallery = $('[data-gallery]', section);
const updatedGallery = $('[data-gallery]', updated);

if (currentGallery && updatedGallery) {
  const currentSlides = Array.from(
    currentGallery.querySelectorAll('[data-media-id]')
  );

  const updatedSlides = Array.from(
    updatedGallery.querySelectorAll('[data-media-id]')
  );

  const currentIds = currentSlides.map(el => el.dataset.mediaId);
  const updatedIds = updatedSlides.map(el => el.dataset.mediaId);

  const sameMedia =
    currentIds.length === updatedIds.length &&
    currentIds.every((id, index) => id === updatedIds[index]);

  if (!sameMedia) {
    const activeSlide = currentSlides.find(el => !el.hidden);
    const activeId = activeSlide?.dataset.mediaId;

    currentGallery.replaceWith(updatedGallery);

    if (activeId) {
      const matchingSlide = updatedSlides.find(
        el => el.dataset.mediaId === activeId
      );

      if (matchingSlide) {
        updatedSlides.forEach(el => {
          el.hidden = el !== matchingSlide;
        });

        updatedGallery.querySelectorAll('[data-thumbnail]').forEach(el => {
          el.setAttribute(
            'aria-pressed',
            String(el.dataset.thumbnail === activeId)
          );
        });
      }
    }
  }
}


/* Update the price */
const currentPrice = $('.product-price', section);
const updatedPrice = $('.product-price', updated);

if (currentPrice && updatedPrice) {
  currentPrice.innerHTML = updatedPrice.innerHTML;
}

/*
 * Update option availability and checked states without replacing
 * the option elements or their event listeners.
 */
const currentOptions = $$(
  '[data-option-value-id]',
  section
);

const updatedOptions = $$(
  '[data-option-value-id]',
  updated
);

currentOptions.forEach(currentInput => {
  const updatedInput = updatedOptions.find(candidate =>
    candidate.name === currentInput.name &&
    candidate.dataset.optionValueId ===
      currentInput.dataset.optionValueId
  );

  if (!updatedInput) return;

  currentInput.checked = updatedInput.checked;
  currentInput.disabled = updatedInput.disabled;

  if (updatedInput.dataset.productUrl) {
    currentInput.dataset.productUrl =
      updatedInput.dataset.productUrl;
  } else {
    delete currentInput.dataset.productUrl;
  }
});

/* Update the selected value displayed inside each option legend */
const currentLegendValues = $$(
  '.product-options legend span',
  section
);

const updatedLegendValues = $$(
  '.product-options legend span',
  updated
);

currentLegendValues.forEach((legendValue, index) => {
  if (updatedLegendValues[index]) {
    legendValue.textContent =
      updatedLegendValues[index].textContent;
  }
});

/*
 * Keep the existing product form so COD-app elements and listeners
 * inserted inside it are not removed.
 */
const currentForm = $('[data-product-form]', section);
const updatedForm = $('[data-product-form]', updated);

const currentVariantInput = currentForm
  ? $('[name="id"]', currentForm)
  : null;

const updatedVariantInput = updatedForm
  ? $('[name="id"]', updatedForm)
  : null;

if (currentVariantInput && updatedVariantInput) {
  currentVariantInput.value = updatedVariantInput.value;
  currentVariantInput.disabled =
    updatedVariantInput.disabled;
}

/* Update quantity limits while preserving the chosen quantity */
const currentQuantity = currentForm
  ? $('[name="quantity"]', currentForm)
  : null;

const updatedQuantity = updatedForm
  ? $('[name="quantity"]', updatedForm)
  : null;

if (currentQuantity && updatedQuantity) {
  ['min', 'max', 'step'].forEach(attribute => {
    if (updatedQuantity.hasAttribute(attribute)) {
      currentQuantity.setAttribute(
        attribute,
        updatedQuantity.getAttribute(attribute)
      );
    } else {
      currentQuantity.removeAttribute(attribute);
    }
  });

  currentQuantity.value = updatedQuantity.value;
}

/* Update Add to Cart and Buy Now states and labels */
[
  '[data-add-button]',
  '[data-buy-now]'
].forEach(selector => {
  const currentButton = currentForm
    ? $(selector, currentForm)
    : null;

  const updatedButton = updatedForm
    ? $(selector, updatedForm)
    : null;

  if (currentButton && updatedButton) {
    currentButton.innerHTML = updatedButton.innerHTML;
    currentButton.disabled = updatedButton.disabled;
  }
});

/* Update the SKU and availability text */
const currentSku = $('.sku', section);
const updatedSku = $('.sku', updated);

if (currentSku && updatedSku) {
  currentSku.innerHTML = updatedSku.innerHTML;
}

/* Update the mobile sticky-cart price and availability */
const currentStickyCart = $('.sticky-cart', section);
const updatedStickyCart = $('.sticky-cart', updated);

if (currentStickyCart && updatedStickyCart) {
  const currentStickyPrice = $('.price', currentStickyCart);
  const updatedStickyPrice = $('.price', updatedStickyCart);

  if (currentStickyPrice && updatedStickyPrice) {
    currentStickyPrice.innerHTML =
      updatedStickyPrice.innerHTML;
  }

  const currentStickyButton = $('button', currentStickyCart);
  const updatedStickyButton = $('button', updatedStickyCart);

  if (currentStickyButton && updatedStickyButton) {
    currentStickyButton.innerHTML =
      updatedStickyButton.innerHTML;

    currentStickyButton.disabled =
      updatedStickyButton.disabled;
  }
}

/* Reinitialize only the updated theme components */
init(section);
updateWhatsApp(section);

document.getElementById(focusId)?.focus({
  preventScroll: true
});

const variant = currentVariantInput?.value;

const address = new URL(location.href);
address.searchParams.delete('option_values');
address.searchParams.delete('variant');

if (variant) {
  address.searchParams.set('variant', variant);
} else {
  address.searchParams.set(
    'option_values',
    selected.join(',')
  );
}

history.replaceState({}, '', address);

/*
 * Notify the COD integration after the form and URL contain
 * the newly selected variant.
 */
if (currentVariantInput) {
  currentVariantInput.dispatchEvent(
    new Event('change', {
      bubbles: true
    })
  );
}

section.dispatchEvent(
  new CustomEvent('variant:change', {
    bubbles: true,
    detail: {
      variantId: variant,
      sectionId: section.dataset.sectionId
    }
  })
);

announce(
  currentPrice?.textContent.trim() ||
  'Options mises à jour'
);

    } catch (error) {
      if (error.name !== 'AbortError') {
        const errorEl = $('.form-error', section); if (errorEl) errorEl.textContent = `${errorMessage(error)} Rechargez la page avant de commander.`;
        // Do not submit the previous variant after a failed option update.
        $$('[name=id], [data-add-button], [data-buy-now], .sticky-cart button', section).forEach(el => el.disabled = true);
        const staleId = $('[name=id]', section); if (staleId) staleId.value = '';
        updateWhatsApp(section);
      }
    } finally {
      if (controllers.get(section) === controller) { section.classList.remove('pending'); section.removeAttribute('aria-busy'); }
    }
  }
  document.addEventListener('change', e => {
    if (e.target.matches('[data-option-value-id]')) changeVariant(e.target);
    else if (e.target.matches('[name=quantity]')) { const section = e.target.closest('[data-product-section]'); if (section) updateWhatsApp(section); }
    else if (e.target.matches('[data-cart-quantity]')) enqueueCart({ id: e.target.dataset.key, quantity: Math.max(0, Math.trunc(Number(e.target.value) || 0)) });
    else if (e.target.matches('[data-cart-note]')) enqueueCart({ note: e.target.value }, 'update');
    else if (e.target.matches('[data-country]')) updateProvince(e.target);
  });
  function showCartError(error) {
    const dialog = $('#CartDrawer'); let el = $('.form-error', dialog?.open ? dialog : $('.cart-page') || document);
    if (!el && dialog) { el = document.createElement('p'); el.className = 'form-error'; el.setAttribute('role', 'alert'); dialog.append(el); }
    if (el) el.textContent = errorMessage(error); announce(errorMessage(error));
  }
  function renderCartSections(sections) {
    if (!sections?.['cart-drawer']) throw new Error('Le panier a été modifié. Rechargez la page pour le consulter.');
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const incoming = $('[data-cart-content]', doc); if (!incoming) throw new Error('Rechargez le panier pour voir les modifications.');
    const active = document.activeElement;
    const activeKey = active?.dataset?.key;
    const noteValue = $('[data-cart-note]', $('#CartDrawer'))?.value;
    $$('[data-cart-content]').forEach((node, i) => {
      const copy = incoming.cloneNode(true), textarea = $('[data-cart-note]', copy), label = $('label[for^="CartNote"]', copy);
      if (textarea) { textarea.id = `CartNote-live-${i}`; if (label) label.htmlFor = textarea.id; }
      node.replaceWith(copy);
    });
    if (activeKey) $$('[data-cart-quantity]').find(x => x.dataset.key === activeKey && x.closest('dialog')?.open)?.focus();
    if (active?.matches?.('[data-cart-note]') && noteValue !== undefined) { const el = $('[data-cart-note]', $('#CartDrawer')); el?.focus(); }
  }
  async function refreshCart() {
    const response = await request(`${route('cart')}?sections=cart-drawer`); renderCartSections(await response.json());
    const cart = await (await request(route('cart.js'))).json(); $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
  }
  function enqueueCart(payload, action = 'change') {
    const drawer = $('#CartDrawer'), page = $('.cart-page');
    [drawer, page].filter(Boolean).forEach(el => el.setAttribute('aria-busy', 'true'));
    cartQueue = cartQueue.catch(() => {}).then(async () => {
      try {
        const cart = await (await request(route(`cart/${action}.js`), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...payload, sections: ['cart-drawer'], sections_url: location.pathname }) })).json();
        renderCartSections(cart.sections); cartMutationError = null;
        $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count); announce('Panier mis à jour');
      } catch (error) { cartMutationError = error; showCartError(error); }
      finally { [drawer, page].filter(Boolean).forEach(el => el.removeAttribute('aria-busy')); }
    });
    return cartQueue;
  }
  document.addEventListener('submit', async e => {
    if (e.target.matches('[data-cart-form]')) {
      e.preventDefault(); const form = e.target, button = e.submitter; if (button) button.disabled = true;
      await cartQueue;
      try {
        if (cartMutationError) throw new Error('Le panier n’a pas été mis à jour. Corrigez la quantité ou rechargez la page avant de commander.');
        await request(route('cart/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: $('[name=note]', form)?.value || '' }) });
        location.assign(route('checkout'));
      } catch (err) { showCartError(err); if (button) button.disabled = false; }
      return;
    }
    if (!e.target.matches('[data-product-form]')) return;
    e.preventDefault(); const form = e.target, submitter = e.submitter;
    const id = $('[name=id]', form); if (!id?.value || id.disabled || form.dataset.submitting) return;
    form.dataset.submitting = 'true'; const buttons = $$('button[type=submit]', form); buttons.forEach(b => b.disabled = true); if (submitter) submitter.disabled = true;
    const errorEl = $('.form-error', form); if (errorEl) errorEl.textContent = '';
    try {
      const body = new FormData(form); body.set('sections', 'cart-drawer'); body.set('sections_url', location.pathname);
      const result = await (await request(route('cart/add.js'), { method: 'POST', body })).json();
      if (submitter?.hasAttribute('data-buy-now')) { location.assign(route('checkout')); return; }
      if (document.body.dataset.cartDrawer !== 'true') { location.assign(route('cart')); return; }
      renderCartSections(result.sections);
      const cart = await (await request(route('cart.js'))).json(); $$('[data-cart-count]').forEach(x => x.textContent = cart.item_count);
      openDialog($('#CartDrawer'), submitter); announce('Le tableau a été ajouté à votre panier.');
    } catch (error) { if (errorEl) errorEl.textContent = errorMessage(error); announce(errorMessage(error)); }
    finally { delete form.dataset.submitting; buttons.forEach(b => b.disabled = false); if (submitter) submitter.disabled = false; }
  });
  function updateProvince(country) {
    const province = document.getElementById(country.dataset.provinceId); if (!province) return;
    let provinces = []; try { provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch (_) {}
    province.replaceChildren(...provinces.map(([value, label]) => new Option(label, value)));
    province.value = province.dataset.selected || ''; province.hidden = !provinces.length;
    const label = $(`label[for="${province.id}"]`); if (label) label.hidden = !provinces.length;
  }
 /* Premium scroll reveals */
  const observed = new WeakSet();
  const activeReveals = new Map();
  const mobileReveal = matchMedia('(max-width: 749px)');

  const revealSelector = [
    '[data-reveal]',
    '.section-heading',
    '.hero-copy',
    '.benefit',
    '.collection-card',
    '.product-card',
    '.editorial-image',
    '.editorial-copy',
    '.steps > div',
    '.review-card',
    '.gallery-tile',
    '.stories-heading',
    '.story',
    '.faq > div',
    '.newsletter-inner > div',
    '.collection-intro',
    '.product-information > h1',
    '.product-intro',
    '.page-content > h1',
    '.page-content > .rte',
    '.contact-section > div',
    '.footer-grid > div',
    '.how-to-order > .page-width > h2'
  ].join(',');

  const observer =
    'IntersectionObserver' in window &&
    typeof Element.prototype.animate === 'function'
      ? new IntersectionObserver(entries => {
          const visible = entries
            .filter(entry => entry.isIntersecting)
            .sort((a, b) =>
              a.boundingClientRect.top - b.boundingClientRect.top ||
              a.boundingClientRect.left - b.boundingClientRect.left
            );

          visible.forEach((entry, index) => {
            const element = entry.target;
            observer.unobserve(element);
element.setAttribute('data-vf-reveal-ready', '');
            if (
              reduced.matches ||
              !element.isConnected ||
              element.matches(':focus-within')
            ) return;

            const compact = mobileReveal.matches;
            const distance = compact ? 10 : 18;

            let effect = element.dataset.reveal;

            if (!effect) {
              if (element.matches('.editorial-image')) {
                effect = 'left';
              } else if (element.matches('.editorial-copy')) {
                effect = 'right';
              } else if (
                element.matches('.gallery-tile, .story')
              ) {
                effect = 'scale';
              } else {
                effect = 'up';
              }
            }

            const transforms = {
              up: `translateY(${distance}px)`,
              left: `translateX(-${distance}px)`,
              right: `translateX(${distance}px)`,
              scale: `scale(${compact ? 0.99 : 0.98})`,
              fade: 'none'
            };

            /* Keep mobile slides vertical and unobtrusive. */
            if (
              compact &&
              (effect === 'left' || effect === 'right')
            ) {
              effect = 'up';
            }

            const animation = element.animate(
              [
                {
                  opacity: 0,
                  transform: transforms[effect] || transforms.up
                },
                {
                  opacity: 1,
                  transform: 'none'
                }
              ],
              {
                duration: compact ? 750 : 1050,
                delay: Math.min(index, 3) * (compact ? 30 : 45),
                easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
                fill: 'both'
              }
            );

            activeReveals.set(element, animation);

            const cleanup = () => activeReveals.delete(element);
            animation.onfinish = cleanup;
            animation.oncancel = cleanup;
          });
        }, { threshold: 0, rootMargin: '0px 0px -24px 0px' })
      : null;

  function initReveals(scope = document) {
  if (!observer) {
    clearTimeout(window.vfRevealFallback);
    document.documentElement.classList.remove('vf-reveal-loading');
    return;
  }

  if (reduced.matches) return;

  const candidates = [
    ...(scope.matches?.(revealSelector) ? [scope] : []),
    ...scope.querySelectorAll(revealSelector)
  ];

  candidates.forEach(element => {
    if (observed.has(element)) return;

    if (
      element.closest('dialog, .sticky-cart, .shopify-app-block') ||
      element.parentElement?.closest(revealSelector)
    ) {
      element.setAttribute('data-vf-reveal-ready', '');
      return;
    }

    observed.add(element);
    observer.observe(element);
  });

  clearTimeout(window.vfRevealFallback);
}

  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      activeReveals.forEach(animation => animation.cancel());
      activeReveals.clear();
    } else {
      initReveals();
    }
  });

  /* Show focused controls immediately during keyboard navigation. */
  document.addEventListener('focusin', event => {
    activeReveals.forEach((animation, element) => {
      if (element.contains(event.target)) animation.cancel();
    });
  });
  function init(scope = document) {
initReveals(scope);    const productSections = scope.matches?.('[data-product-section]') ? [scope] : $$('[data-product-section]', scope);
    productSections.forEach(updateWhatsApp);
    $$('[data-country]', scope).forEach(country => { if (country.dataset.selected) country.value = country.dataset.selected; updateProvince(country); });
    $$('[data-recommendations]', scope).forEach(node => {
      if (node.dataset.loaded) return; node.dataset.loaded = 'true';
      recommendationLoads.push((async () => { try { const html = await (await request(node.dataset.url)).text(); const doc = new DOMParser().parseFromString(html, 'text/html'), replacement = $('[data-recommendations]', doc); if (replacement) { node.innerHTML = replacement.innerHTML; init(node); } } catch (_) { /* optional recommendations remain absent */ } })());
    });
  }
  async function recentlyViewed() {
    await Promise.allSettled(recommendationLoads);
    const section = $('[data-recently-viewed]'), product = $('[data-product-section]');
    let handles = [];
    try { const saved = JSON.parse(localStorage.getItem('vf_recent') || '[]'); handles = Array.isArray(saved) ? saved.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)).slice(0,8) : []; } catch (_) {}
    if (section) {
      const excluded = new Set([section.dataset.current]);
      $$('[data-recommendations] a[href*="/products/"]').forEach(a => { const match = a.pathname.match(/\/products\/([^/]+)/); if (match) excluded.add(match[1]); });
      const previous = handles.filter(h => !excluded.has(h)).slice(0,4);
      const results = await Promise.allSettled(previous.map(async handle => {
        const html = await (await request(`${route(`products/${encodeURIComponent(handle)}`)}?section_id=product-card-fragment`)).text();
        return $('.product-card', new DOMParser().parseFromString(html, 'text/html'));
      }));
      const cards = results.filter(r => r.status === 'fulfilled' && r.value).map(r => r.value);
      if (cards.length) { $('[data-recent-grid]', section).replaceChildren(...cards); section.hidden = false; init(section); }
    }
    if (product) try { localStorage.setItem('vf_recent', JSON.stringify([product.dataset.productHandle, ...handles.filter(h => h !== product.dataset.productHandle)].slice(0,8))); } catch (_) {}
  }
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => $$('[data-reveal]', e.target).forEach(el => observer?.unobserve(el)));
  init(); recentlyViewed();
})();
document.querySelectorAll('[data-gallery]').forEach((gallery) => {
  const slides = Array.from(gallery.querySelectorAll('.media-slide'));
  const thumbnails = Array.from(
    gallery.querySelectorAll('[data-thumbnail]')
  );

  const prev = gallery.querySelector('.gallery-arrow--prev');
  const next = gallery.querySelector('.gallery-arrow--next');

  if (!slides.length || !prev || !next) return;

  function getCurrentIndex() {
    const index = slides.findIndex((slide) => !slide.hidden);
    return index >= 0 ? index : 0;
  }

  function showSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;

    slides.forEach((slide, i) => {
      slide.hidden = i !== index;
    });

    thumbnails.forEach((thumbnail, i) => {
      thumbnail.setAttribute(
        'aria-pressed',
        i === index ? 'true' : 'false'
      );
    });
  }

  prev.addEventListener('click', () => {
    showSlide(getCurrentIndex() - 1);
  });

  next.addEventListener('click', () => {
    showSlide(getCurrentIndex() + 1);
  });
});